import { Checkbox } from "@headlessui/react";
import { useField } from "formik";
import { HiOutlineCheck } from "react-icons/hi";
import P from "../../typography/P";

const FormikCheckbox = ({ name, label, onChange = () => {} }) => {
    const [field, meta, helpers] = useField(name);

    const isChecked = field.value;

    const toggleValue = () => {
        helpers.setTouched(true);
        helpers.setValue(!field.value);
        onChange(field.value);
    };

    return (
        <>
            <label className="flex items-center space-x-1 cursor-pointer">
                <Checkbox
                    checked={isChecked}
                    onChange={toggleValue}
                    className={`group size-1.6 rounded-md  bg-white ring-1 ring-blue-50  flex items-center justify-center 
    data-[checked]:bg-white  data-[focus]:outline data-[focus]:outline-offset-2 data-[focus]:outline-blue-50
  `}
                >
                    <HiOutlineCheck className="hidden size-2 text-blue group-data-[checked]:block" />
                </Checkbox>
                {label && (
                    <P className="text-xs md:text-sm xl:text-sm font-vietnam text-nowrap text-primary">
                        {label}
                    </P>
                )}
            </label>
        </>
    );
};

export default FormikCheckbox;
